import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomainPageComponent } from '@technocom/core';
import { ActivatedRoute } from '@angular/router';
import { SimpleAttachmentLinkService } from '@technocom/data';

@Component({
  selector: 'app-mobile-download-page',
  templateUrl: './mobile-download-page.component.html',
  styleUrls: ['./mobile-download-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileDownloadPageComponent extends DomainPageComponent {
  images = [
    { url: 'assets/mobile-pictures/mobile_1.webp' },
    { url: 'assets/mobile-pictures/mobile_2.webp' },
    { url: 'assets/mobile-pictures/mobile_3.webp' },
    { url: 'assets/mobile-pictures/mobile_4.webp' },
    { url: 'assets/mobile-pictures/mobile_5.webp' },
  ];

  qrAppstoreImage = 'assets/mobile-pictures/qrcode_url_appstore.png';
  qrPlayMarketImage = 'assets/mobile-pictures/qrcode_url_playmarket.png';

  appStoreLink = 'https://apps.apple.com/ru/app/мигрант-югра/id1635323552';
  playMarketLink = 'https://play.google.com/store/apps/details?id=com.technocom.migrant';
  protected linksService = inject(SimpleAttachmentLinkService);

  goToAppStore() {
    void this.linksService.open(this.appStoreLink);
  }

  goToPlayMarket() {
    void this.linksService.open(this.playMarketLink);
  }
}
